export const PROFILE_CONTAINER_TEST_ID = 'PROFILE_CONTAINER_TEST_ID';
export const PROFILE_NAVBAR_TEST_ID = 'PROFILE_NAVBAR_TEST_ID';

export const PROFILE_TOP_PADDING = 32;
